
(function () {
  'use strict';

  var CLASE_ABIERTO = 'vqa--abierto';

  var mapaTallas = {};

  var estado = {
    datos: null,
    tarjeta: null,
    disparador: null,
    indiceMedia: 0,
    seleccion: {},
    anadiendo: false,
    pendiente: null,
    anadido: false,
    cerrando: false,
    teclado: false,
    overflow: ''
  };


  function $(sel, raiz) { return (raiz || document).querySelector(sel); }
  function $$(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }

  function numero(t, porDefecto) {
    var n = parseFloat(t);
    return isNaN(n) ? porDefecto : n;
  }

  function normalizar(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function esOpcionTalla(opcion) {
    for (var i = 0; i < opcion.valores.length; i++) {
      var v = opcion.valores[i];
      if (mapaTallas[v] || /^\s*\d+(?:[.,]\d+)?\s*[x×]\s*\d+/i.test(String(v))) return true;
    }
    return /(^|\b)(size|talla|tamano|format|formato|taille)(\b|$)/.test(normalizar(opcion.nombre));
  }

  function muestrasPropias(refs) {
    var propias = {};
    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) {
      propias[normalizar(b.getAttribute('data-vqa-acabado'))] = true;
    });
    var obra = refs.marcosObra || {};
    Object.keys(obra).forEach(function (h) { propias[normalizar(obra[h])] = true; });
    return propias;
  }
  function esOpcionAcabado(opcion, refs) {
    var propias = muestrasPropias(refs);
    for (var i = 0; i < opcion.valores.length; i++) {
      if (propias[normalizar(opcion.valores[i])]) return true;
    }
    return /(^|\b)(finish|frame|acabado|marco|moldura|finition|cadre)(\b|$)/.test(normalizar(opcion.nombre));
  }
  function todasConMuestra(opcion, refs) {
    var propias = muestrasPropias(refs);
    for (var i = 0; i < opcion.valores.length; i++) {
      if (!propias[normalizar(opcion.valores[i])]) return false;
    }
    return true;
  }

  function esOpcionFicticia(opcion) {
    return normalizar(opcion.nombre) === 'title'
      && opcion.valores.length === 1
      && normalizar(opcion.valores[0]) === 'default title';
  }


  function variantePorSeleccion(datos, seleccion) {
    var nombres = datos.opciones.map(function (o) { return o.nombre; });
    for (var i = 0; i < datos.variantes.length; i++) {
      var v = datos.variantes[i];
      var casa = true;
      for (var j = 0; j < nombres.length; j++) {
        if (seleccion[nombres[j]] !== undefined && v.opts[j] !== seleccion[nombres[j]]) {
          casa = false; break;
        }
      }
      if (casa) return v;
    }
    return null;
  }

  function valorDisponible(datos, nombreOpcion, valor, seleccion) {
    var nombres = datos.opciones.map(function (o) { return o.nombre; });
    var idx = nombres.indexOf(nombreOpcion);
    if (idx === -1) return true;
    return datos.variantes.some(function (v) {
      if (v.opts[idx] !== valor) return false;
      for (var j = 0; j < nombres.length; j++) {
        if (j === idx) continue;
        if (seleccion[nombres[j]] !== undefined && v.opts[j] !== seleccion[nombres[j]]) return false;
      }
      return v.disponible;
    });
  }

  function conValor(seleccion, nombre, valor) {
    var copia = {};
    for (var k in seleccion) copia[k] = seleccion[k];
    copia[nombre] = valor;
    return copia;
  }

  function formatearCorto(cents) {
    return window.VeeryCarrito ? window.VeeryCarrito.dinero(cents, { sinCeros: true }) : String(cents / 100);
  }

  var CLAVE_ELECCION = 'veery-qa-eleccion';

  function elecciones() {
    try { return JSON.parse(sessionStorage.getItem(CLAVE_ELECCION) || '{}') || {}; } catch (e) { return {}; }
  }

  function guardarEleccion(handle, seleccion) {
    if (!handle) return;
    try {
      var todas = elecciones();
      if (seleccion) todas[handle] = seleccion;
      else if (todas[handle]) delete todas[handle];
      else return;
      sessionStorage.setItem(CLAVE_ELECCION, JSON.stringify(todas));
    } catch (e) {}
  }

  function copiaDe(seleccion) {
    var copia = {};
    for (var k in seleccion) copia[k] = seleccion[k];
    return copia;
  }

  function eleccionRecordada(datos) {
    var guardada = datos.handle ? elecciones()[datos.handle] : null;
    if (!guardada) return;
    var prueba = copiaDe(estado.seleccion);
    datos.opciones.forEach(function (o) {
      if (o.valores.indexOf(guardada[o.nombre]) !== -1) prueba[o.nombre] = guardada[o.nombre];
    });
    if (variantePorSeleccion(datos, prueba)) estado.seleccion = prueba;
  }


  function construir(panel, datos) {
    var refs = panel.__vqaRefs;

    refs.titulo.textContent = datos.titulo;
    refs.enlace.setAttribute('href', datos.url);

    var quien = (datos.artista || '').trim();
    refs.artista.textContent = '';
    if (quien) {
      refs.artista.appendChild(document.createTextNode(refs.textoPor + ' '));
      var negrita = document.createElement('b');
      negrita.textContent = quien;
      refs.artista.appendChild(negrita);
    }
    refs.eyebrowPor.textContent = quien ? ' · ' + refs.textoPor + ' ' + quien : '';
    refs.insignia.hidden = !datos.insignia;

    if (refs.wish && datos.handle) {
      refs.wish.setAttribute('data-product-handle', datos.handle);
      refs.wish.setAttribute('data-product-image', datos.miniatura || '');
      pintarCorazon(refs);
    }

    if (refs.guiaCaja) refs.guiaCaja.hidden = true;
    if (refs.guiaBtn) refs.guiaBtn.setAttribute('aria-expanded', 'false');

    estado.indiceMedia = 0;
    pintarGaleria(panel, datos);

    estado.seleccion = {};
    var inicial = null;
    for (var i = 0; i < datos.variantes.length; i++) {
      if (datos.variantes[i].id === datos.varianteInicial) { inicial = datos.variantes[i]; break; }
    }
    if (!inicial) inicial = datos.variantes[0];
    if (inicial) {
      datos.opciones.forEach(function (o, idx) { estado.seleccion[o.nombre] = inicial.opts[idx]; });
    }
    eleccionRecordada(datos);

    estado.anadiendo = false;
    estado.pendiente = null;
    ocultarHecho(panel);
    pintarOpciones(panel, datos);
    sincronizar(panel, datos);
  }

  function pintarCorazon(refs) {
    var handle = refs.wish ? refs.wish.getAttribute('data-product-handle') : '';
    if (!handle) return;
    var guardado = false;
    try {
      guardado = !!(window.VeeryWishlist && window.VeeryWishlist.has(handle));
    } catch (e) { guardado = false; }
    refs.wish.setAttribute('data-guardado', guardado ? 'true' : 'false');
    var etiqueta = guardado
      ? refs.wish.getAttribute('data-label-remove')
      : refs.wish.getAttribute('data-label-add');
    if (etiqueta) refs.wish.setAttribute('aria-label', etiqueta);
    var txt = $('.vqa__wish-texto', refs.wish);
    if (txt && etiqueta && txt.textContent !== etiqueta) txt.textContent = etiqueta;
  }

  function pintarGaleria(panel, datos) {
    var refs = panel.__vqaRefs;
    var imgs = datos.media;

    refs.puntos.innerHTML = '';
    refs.pista.innerHTML = '';
    refs.imagen = null;

    if (!imgs.length) {
      refs.flechaPrev.hidden = true;
      refs.flechaSig.hidden = true;
      return;
    }

    imgs.forEach(function (m, i) {
      var slide = document.createElement('div');
      slide.className = i === 0 ? 'vqa__slide vqa__slide--marco' : 'vqa__slide';

      var img = document.createElement('img');
      img.className = i === 0 ? 'vqa__imagen vqa__imagen--obra' : 'vqa__imagen';
      img.src = m.src;
      img.alt = m.alt || datos.titulo;
      img.decoding = 'async';
      img.width = 800; img.height = 1000;
      if (i > 0) img.loading = 'lazy';
      img.draggable = false;
      slide.appendChild(img);

      if (i === 0) {
        refs.imagen = img;
        img.addEventListener('load', function () {
          aplicarMarco(refs);
        });
      }

      refs.pista.appendChild(slide);
    });

    var varias = imgs.length > 1;
    refs.flechaPrev.hidden = !varias;
    refs.flechaSig.hidden = !varias;

    if (varias) {
      imgs.forEach(function (m, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vqa__punto';
        b.setAttribute('data-vqa-punto', String(i));
        b.setAttribute('aria-label', refs.plantillaPunto.replace('__n__', String(i + 1)));
        refs.puntos.appendChild(b);
      });
    }

    reiniciarCarrusel(panel);
  }

  function reiniciarCarrusel(panel) {
    var refs = panel && panel.__vqaRefs;
    if (!refs || !refs.pista) return;
    estado.indiceMedia = 0;
    refs.sigueDedo = false;
    refs.pista.style.scrollBehavior = 'auto';
    refs.pista.scrollLeft = 0;
    refs.pista.style.scrollBehavior = '';
    marcarPunto(refs, 0);
  }

  function marcarPunto(refs, indice) {
    refs.puntoVisto = indice;
    var puntos = $$('[data-vqa-punto]', refs.puntos);
    puntos.forEach(function (b, i) {
      var activo = i === indice;
      b.classList.toggle('vqa__punto--activo', activo);
      b.setAttribute('aria-current', activo ? 'true' : 'false');
    });

  }

  function mostrarMedia(panel, datos, indice) {
    var refs = panel.__vqaRefs;
    var imgs = datos.media;
    if (!imgs.length || !refs.pista) return;

    var n = imgs.length;
    var i = ((indice % n) + n) % n;
    estado.indiceMedia = i;
    refs.sigueDedo = false;

    refs.pista.scrollTo({ left: refs.pista.clientWidth * i, behavior: 'smooth' });
    marcarPunto(refs, i);
  }

  function indiceSegunScroll(refs) {
    var ancho = refs.pista.clientWidth || 1;
    return Math.round(refs.pista.scrollLeft / ancho);
  }

  function pintarOpciones(panel, datos) {
    var refs = panel.__vqaRefs;
    refs.marcosObra = datos.marcos || {};
    refs.talla.innerHTML = '';
    refs.otras.innerHTML = '';
    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) { b.hidden = true; });

    var hayTalla = false, hayAcabado = false;

    datos.opciones.forEach(function (opcion) {
      if (esOpcionFicticia(opcion)) return;

      if (esOpcionAcabado(opcion, refs) && todasConMuestra(opcion, refs)) {
        hayAcabado = true;
        configurarAcabados(refs, opcion);
      } else if (esOpcionTalla(opcion) && !hayTalla) {
        hayTalla = true;
        refs.talla.appendChild(botonesTalla(opcion, refs.preciosTallas));
      } else {
        refs.otras.appendChild(desplegable(opcion));
      }
    });

    refs.filaTalla.hidden = !hayTalla && !refs.otras.children.length;
    refs.filaAcabado.hidden = !hayAcabado;
  }

  function botonesTalla(opcion, conPrecio) {
    var grupo = document.createElement('div');
    grupo.className = 'vqa__tallas';
    grupo.setAttribute('role', 'radiogroup');
    grupo.setAttribute('aria-label', opcion.nombre);

    opcion.valores.forEach(function (valor) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vqa__talla';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-vqa-talla-valor', valor);
      b.setAttribute('data-vqa-opcion-nombre', opcion.nombre);
      if (conPrecio) {
        var texto = document.createElement('span');
        texto.className = 'vqa__talla-texto';
        texto.textContent = mapaTallas[valor] || valor;
        var precio = document.createElement('span');
        precio.className = 'vqa__talla-precio';
        precio.setAttribute('data-vqa-talla-precio', '');
        b.appendChild(texto);
        b.appendChild(precio);
      } else {
        b.textContent = mapaTallas[valor] || valor;
      }
      grupo.appendChild(b);
    });
    return grupo;
  }

  function desplegable(opcion) {
    var envoltura = document.createElement('div');
    envoltura.className = 'vqa__select-caja';

    var sel = document.createElement('select');
    sel.className = 'vqa__select';
    sel.setAttribute('data-vqa-opcion', opcion.nombre);
    sel.setAttribute('aria-label', opcion.nombre);

    opcion.valores.forEach(function (valor) {
      var op = document.createElement('option');
      op.value = valor;
      op.textContent = valor;
      if (estado.seleccion[opcion.nombre] === valor) op.selected = true;
      sel.appendChild(op);
    });

    envoltura.appendChild(sel);

    var chevron = document.createElement('span');
    chevron.className = 'vqa__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    envoltura.appendChild(chevron);

    return envoltura;
  }

  function configurarAcabados(refs, opcion) {
    var ofrecidos = {};
    opcion.valores.forEach(function (v) { ofrecidos[normalizar(v)] = v; });

    var obra = refs.marcosObra || {};
    $$('[data-vqa-acabado]', refs.acabado).forEach(function (b) {
      var valorReal = ofrecidos[normalizar(b.getAttribute('data-vqa-acabado'))]
        || ofrecidos[normalizar(obra[b.getAttribute('data-frame-handle')])];
      if (!valorReal) { b.hidden = true; return; }
      b.hidden = false;
      b.setAttribute('data-vqa-valor', valorReal);
      b.setAttribute('data-vqa-opcion-nombre', opcion.nombre);
    });
  }


  function activarArrastre(panel) {
    var refs = panel.__vqaRefs;
    var pista = refs.pista;
    if (!pista) return;

    var abajo = false, arrastrando = false, huboArrastre = false;
    var inicioX = 0, inicioScroll = 0, pointerId = null;
    var UMBRAL = 8;

    pista.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

    pista.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
      abajo = true; arrastrando = false; huboArrastre = false;
      inicioX = ev.clientX;
      inicioScroll = pista.scrollLeft;
      pointerId = ev.pointerId;
    });

    pista.addEventListener('pointermove', function (ev) {
      if (!abajo) return;
      var dx = ev.clientX - inicioX;
      if (!arrastrando && Math.abs(dx) > UMBRAL) {
        arrastrando = true; huboArrastre = true;
        pista.classList.add('vqa--arrastrando');
        try { pista.setPointerCapture(pointerId); } catch (e) {}
      }
      if (arrastrando) {
        ev.preventDefault();
        pista.scrollLeft = inicioScroll - dx;
      }
    });

    function fin() {
      if (!abajo) return;
      abajo = false;
      if (!arrastrando) { pointerId = null; return; }
      try { if (pointerId !== null) pista.releasePointerCapture(pointerId); } catch (e) {}
      arrastrando = false; pointerId = null;
      pista.classList.remove('vqa--arrastrando');

      var i = indiceSegunScroll(refs);
      estado.indiceMedia = i;
      pista.scrollTo({ left: pista.clientWidth * i, behavior: 'smooth' });
      marcarPunto(refs, i);
    }

    pista.addEventListener('pointerup', fin);
    pista.addEventListener('pointercancel', fin);
    pista.addEventListener('pointerleave', fin);

    pista.addEventListener('click', function (ev) {
      if (huboArrastre) { ev.preventDefault(); ev.stopPropagation(); huboArrastre = false; }
    }, true);

    var t = null;
    refs.sigueDedo = true;
    var tocar = function () { refs.sigueDedo = true; };
    pista.addEventListener('touchstart', tocar, { passive: true });
    pista.addEventListener('pointerdown', tocar);
    pista.addEventListener('wheel', tocar, { passive: true });
    pista.addEventListener('scroll', function () {
      if (refs.sigueDedo) {
        var ya = indiceSegunScroll(refs);
        if (ya !== refs.puntoVisto) marcarPunto(refs, ya);
      }
      clearTimeout(t);
      t = setTimeout(function () {
        var i = indiceSegunScroll(refs);
        if (i === estado.indiceMedia) return;
        estado.indiceMedia = i;
        marcarPunto(refs, i);
      }, 90);
    }, { passive: true });
  }


  function marcoElegido(refs) {
    return $$('[data-vqa-acabado]', refs.acabado).filter(function (b) {
      return !b.hidden && b.getAttribute('aria-checked') === 'true';
    })[0] || null;
  }

  function aplicarMarco(refs) {
    var lienzo = refs.lienzo;
    if (!lienzo || !estado.datos) return;
    var partes = String(valorTalla(estado.datos, refs)).toLowerCase().replace(/\s/g, '').split(/[x×]/);
    var w = parseFloat(partes[0]) * 10;
    var h = parseFloat(partes[1]) * 10;
    if (!(w > 0 && h > 0)) { w = 400; h = 0; }
    if (!refs.marcoRecorte || !h) {
      var img = refs.imagen;
      var r = img && img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 2 / 3;
      h = Math.round((w / r) * 100) / 100;
    }
    var elegido = marcoElegido(refs);
    var familia = elegido && !elegido.hasAttribute('data-vqa-sin-marco')
      ? (elegido.getAttribute('data-vqa-familia') || 'negro') : '';
    var valores = {
      '--vqa-w': w,
      '--vqa-h': h,
      '--vqa-con-marco': familia ? 1 : 0,
      '--vqa-perfil': familia ? refs.marcoPerfil : 0,
      '--vqa-vuelo': familia ? refs.marcoVuelo : 0
    };
    if (familia) {
      valores['--vqa-borde'] = 'var(--veery-marco-borde-' + familia + ')';
      valores['--vqa-color'] = 'var(--veery-marco-color-' + familia + ')';
      valores['--vqa-sombra'] = 'var(--veery-marco-sombra-' + familia + ')';
    }
    for (var k in valores) {
      if (lienzo.style.getPropertyValue(k) !== String(valores[k])) lienzo.style.setProperty(k, String(valores[k]));
    }
  }

  function valorTalla(datos, refs) {
    var valor = '';
    datos.opciones.forEach(function (o) {
      if (valor || esOpcionFicticia(o) || esOpcionAcabado(o, refs) || !esOpcionTalla(o)) return;
      valor = estado.seleccion[o.nombre] || '';
    });
    return valor;
  }

  function textoTalla(datos, refs) {
    var v = valorTalla(datos, refs);
    return mapaTallas[v] || v || '';
  }

  function sincronizar(panel, datos) {
    var refs = panel.__vqaRefs;
    var v = variantePorSeleccion(datos, estado.seleccion);

    var precio = v ? v.precioCorto : datos.precio;
    refs.precio.textContent = precio;
    refs.ctaPrecio.textContent = precio;
    var antes = v && v.a ? v.a : '';
    if (refs.rebaja) {
      refs.rebaja.hidden = !antes;
      refs.antes.textContent = antes;
      refs.pct.hidden = !(antes && v.q > 0);
      refs.pct.textContent = antes && v.q > 0 ? refs.pct.getAttribute('data-vqa-plantilla').replace('__PCT__', v.q) : '';
    }
    if (refs.legal) {
      refs.legal.hidden = !antes;
      refs.legal.textContent = antes ? refs.legal.getAttribute('data-vqa-plantilla').replace('__P__', antes) : '';
    }

    var comprable = !!(v && v.disponible);
    if (!estado.anadiendo) {
      refs.cta.disabled = !comprable;
      refs.ctaTexto.textContent = comprable ? refs.textoAnadir : refs.textoAgotado;
      refs.ctaPrecio.hidden = !comprable;
      refs.ctaSep.hidden = !comprable;
    }

    if (v && datos.url) {
      refs.enlace.setAttribute('href', datos.url + (datos.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id);
    }

    var escala = 1;
    $$('[data-vqa-talla-valor]', refs.talla).forEach(function (b, i, todos) {
      var nombre = b.getAttribute('data-vqa-opcion-nombre');
      var valor = b.getAttribute('data-vqa-talla-valor');
      var elegido = estado.seleccion[nombre] === valor;
      b.setAttribute('aria-checked', elegido ? 'true' : 'false');
      b.tabIndex = elegido ? 0 : -1;
      b.classList.toggle('vqa__talla--agotada', !valorDisponible(datos, nombre, valor, estado.seleccion));
      var precioTalla = $('[data-vqa-talla-precio]', b);
      if (precioTalla) {
        var vt = variantePorSeleccion(datos, conValor(estado.seleccion, nombre, valor));
        var textoPrecio = vt ? vt.precioCorto : '';
        var antesTalla = vt && vt.a ? vt.a : '';
        var clave = antesTalla + '|' + textoPrecio;
        if (precioTalla.getAttribute('data-vqa-clave') !== clave) {
          precioTalla.setAttribute('data-vqa-clave', clave);
          precioTalla.textContent = '';
          if (antesTalla) {
            var tachado = document.createElement('s');
            tachado.className = 'vqa__talla-antes';
            tachado.textContent = antesTalla;
            precioTalla.append(tachado, ' ');
          }
          precioTalla.append(textoPrecio);
        }
      }
      if (elegido && todos.length > 1) escala = (70 + 16 * i / (todos.length - 1)) / 86;
    });
    if (refs.lienzo && refs.lienzo.style.getPropertyValue('--vqa-escala') !== String(escala)) {
      refs.lienzo.style.setProperty('--vqa-escala', String(escala));
    }

    var marcos = $$('[data-vqa-acabado]', refs.acabado).filter(function (b) { return !b.hidden; });
    var nombreMarco = marcos.length ? marcos[0].getAttribute('data-vqa-opcion-nombre') : null;
    var base = null;
    if (nombreMarco) {
      var sinMarco = marcos.filter(function (b) { return b.hasAttribute('data-vqa-sin-marco'); })[0];
      var vBase = sinMarco ? variantePorSeleccion(datos, conValor(estado.seleccion, nombreMarco, sinMarco.getAttribute('data-vqa-valor'))) : null;
      if (vBase && typeof vBase.c === 'number') base = vBase.c;
      if (base === null) {
        marcos.forEach(function (b) {
          var vm = variantePorSeleccion(datos, conValor(estado.seleccion, nombreMarco, b.getAttribute('data-vqa-valor')));
          if (vm && typeof vm.c === 'number' && (base === null || vm.c < base)) base = vm.c;
        });
      }
    }

    var etiquetaMarco = '';
    marcos.forEach(function (b) {
      var valor = b.getAttribute('data-vqa-valor');
      var nombre = b.getAttribute('data-vqa-nombre') || valor;
      var vm = variantePorSeleccion(datos, conValor(estado.seleccion, nombreMarco, valor));
      var recargo = vm && typeof vm.c === 'number' && base !== null ? vm.c - base : 0;
      var textoRecargo = recargo > 0 ? '+' + formatearCorto(recargo) : '';
      var hay = valorDisponible(datos, nombreMarco, valor, estado.seleccion);
      var elegido = estado.seleccion[nombreMarco] === valor;

      b.setAttribute('aria-checked', elegido ? 'true' : 'false');
      b.tabIndex = elegido ? 0 : -1;
      b.classList.toggle('vqa__marco--agotado', !hay);
      b.setAttribute('aria-label', nombre + (textoRecargo ? ', ' + textoRecargo : ''));
      var rec = $('[data-vqa-recargo]', b);
      if (rec) rec.textContent = textoRecargo || '—';
      if (elegido) etiquetaMarco = nombre + (textoRecargo ? ' · ' + textoRecargo : '');
    });
    refs.marcoNombre.textContent = etiquetaMarco;

    aplicarMarco(refs);

    if (v) {
      refs.anuncio.textContent = v.opts.join(' / ') + ' · ' + precio + (comprable ? '' : ' · ' + refs.textoAgotado);
    }
  }


  var guias = {};

  function urlGuia(datos) {
    if (!datos || !datos.url) return '';
    return String(datos.url).split('#')[0].split('?')[0] + '?section_id=veery-guia-rapida';
  }

  function pedirGuia(datos) {
    var url = urlGuia(datos);
    if (!url) return Promise.reject(new Error('sin url'));
    if (!guias[url]) {
      guias[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        if (html.indexOf('data-vsg-open') === -1) throw new Error('sin guía');
        return html;
      });
      guias[url].catch(function () { delete guias[url]; });
    }
    return guias[url];
  }

  function montarGuia(panel, html, url) {
    var host = $('[data-vqa-guia-host]', panel);
    if (!host) {
      host = document.createElement('div');
      host.className = 'vqa__guia-host';
      host.setAttribute('data-vqa-guia-host', '');
      panel.appendChild(host);
    }
    if (host.getAttribute('data-vqa-guia-url') === url) return host;
    $$('.vsg__modal, [data-vesc]', host).forEach(function (vieja) {
      vieja.dispatchEvent(new CustomEvent('veery:desmontar'));
    });
    host.innerHTML = html;
    host.setAttribute('data-vqa-guia-url', url);
    $$('script', host).forEach(function (viejo) {
      var nuevo = document.createElement('script');
      for (var i = 0; i < viejo.attributes.length; i++) nuevo.setAttribute(viejo.attributes[i].name, viejo.attributes[i].value);
      nuevo.textContent = viejo.textContent;
      viejo.parentNode.replaceChild(nuevo, viejo);
    });
    return host;
  }

  function seleccionParaGuia(panel, datos) {
    var refs = panel.__vqaRefs;
    var r = { talla: '', marco: '' };
    datos.opciones.forEach(function (o) {
      var v = estado.seleccion[o.nombre];
      if (v === undefined || esOpcionFicticia(o)) return;
      if (esOpcionAcabado(o, refs)) r.marco = v;
      else if (esOpcionTalla(o)) r.talla = v;
    });
    return r;
  }

  function alternarTabla(panel) {
    var refs = panel.__vqaRefs;
    if (!refs.guiaCaja) return;
    var abierta = !refs.guiaCaja.hidden;
    refs.guiaCaja.hidden = abierta;
    if (refs.guiaBtn) refs.guiaBtn.setAttribute('aria-expanded', abierta ? 'false' : 'true');
  }

  function abrirGuia(panel) {
    var datos = estado.datos;
    var url = urlGuia(datos);
    pedirGuia(datos).then(function (html) {
      if (estado.datos !== datos || !panel.open) return;
      var host = montarGuia(panel, html, url);
      var abridor = $('[data-vsg-open]', host);
      var ventana = abridor && document.getElementById(abridor.getAttribute('data-vsg-open'));
      if (!ventana) throw new Error('guía incompleta');
      ventana.setAttribute('data-vsg-destino', 'compra-rapida');
      ventana.setAttribute('data-vsg-inicial', JSON.stringify(seleccionParaGuia(panel, datos)));
      abridor.click();
    }).catch(function () {
      if (estado.datos === datos && panel.open) alternarTabla(panel);
    });
  }

  function aplicarDesdeGuia(panel, detalle) {
    var datos = estado.datos;
    if (!datos || !detalle) return;
    var refs = panel.__vqaRefs;
    datos.opciones.forEach(function (o) {
      if (esOpcionFicticia(o)) return;
      var buscado = esOpcionAcabado(o, refs) ? detalle.marcoEtiqueta : (esOpcionTalla(o) ? detalle.talla : '');
      if (!buscado) return;
      var hallado = false;
      for (var i = 0; i < o.valores.length; i++) {
        if (normalizar(o.valores[i]) === normalizar(buscado)) { estado.seleccion[o.nombre] = o.valores[i]; hallado = true; break; }
      }
      if (!hallado && esOpcionAcabado(o, refs)) {
        var muestra = $$('[data-vqa-acabado]', refs.acabado).filter(function (b) {
          return !b.hidden && normalizar(b.getAttribute('data-vqa-acabado')) === normalizar(buscado);
        })[0];
        if (muestra && muestra.getAttribute('data-vqa-valor')) estado.seleccion[o.nombre] = muestra.getAttribute('data-vqa-valor');
      }
    });
    ocultarHecho(panel);
    pintarOpciones(panel, datos);
    sincronizar(panel, datos);
  }

  function elegir(panel, nombre, valor) {
    if (!nombre || estado.seleccion[nombre] === valor) return;
    estado.seleccion[nombre] = valor;
    ocultarHecho(panel);
    sincronizar(panel, estado.datos);
  }


  function anadir(panel) {
    var datos = estado.datos;
    var refs = panel.__vqaRefs;
    if (!datos || estado.anadiendo) return;

    var v = variantePorSeleccion(datos, estado.seleccion);
    if (!v || !v.disponible) return;

    enVuelo[String(v.id)] = { handle: datos.handle, seleccion: copiaDe(estado.seleccion) };

    if (!datos.regalo && cajonAlInstante()) {
      document.dispatchEvent(new CustomEvent('veery:cajon:linea', { detail: lineaProvisional(datos, refs, v) }));
      anadirPorSuCuenta(v.id);
      estado.haciaCajon = true;
      cerrar(panel);
      return;
    }

    estado.anadiendo = true;
    estado.pendiente = { variante: v.id, datos: datos };
    ocultarError(panel);
    refs.cta.disabled = true;
    refs.ctaTexto.textContent = refs.textoAnadiendo;
    refs.ctaPrecio.hidden = true;
    refs.ctaSep.hidden = true;
    anadirPorSuCuenta(v.id);
  }

  function cajonAlInstante() {
    var c = document.getElementById('hv-cart-drawer');
    return c && c.hasAttribute('data-hv-al-instante') && window.__hvProvisional && typeof c.showDialog === 'function' ? c : null;
  }

  function lineaProvisional(datos, refs, v) {
    var marco = marcoElegido(refs);
    return {
      variante: String(v.id),
      imagen: v.i || datos.miniatura || '',
      alt: datos.miniaturaAlt || datos.titulo || '',
      titulo: datos.titulo || '',
      opciones: [textoTalla(datos, refs), marco ? (marco.getAttribute('data-vqa-nombre') || marco.getAttribute('data-vqa-valor')) : ''],
      centimos: typeof v.c === 'number' ? v.c : undefined,
      precio: v.precioCorto,
      envio: true
    };
  }

  function mostrarError(panel, mensaje) {
    var refs = panel.__vqaRefs;
    var texto = mensaje || refs.textoError;
    if (refs.error) {
      refs.error.textContent = texto;
      refs.error.hidden = false;
    }
    refs.anuncio.textContent = texto;
  }

  function ocultarError(panel) {
    var refs = panel.__vqaRefs;
    if (!refs.error || refs.error.hidden) return;
    refs.error.hidden = true;
    refs.error.textContent = '';
  }

  function mostrarHecho(panel) {
    var refs = panel.__vqaRefs;
    var datos = estado.datos;
    estado.anadiendo = false;
    estado.anadido = true;
    sincronizar(panel, datos);

    var partes = [];
    var talla = textoTalla(datos, refs);
    if (talla) partes.push(talla);
    var marco = marcoElegido(refs);
    if (marco) partes.push(marco.getAttribute('data-vqa-nombre') || marco.getAttribute('data-vqa-valor'));
    partes.push(refs.precio.textContent);

    refs.hechoDetalle.textContent = partes.join(' · ');
    refs.cta.hidden = true;
    refs.hecho.hidden = false;
    refs.anuncio.textContent = refs.textoAnadido + ' · ' + partes.join(' · ');
    if (estado.teclado && refs.verCarrito) refs.verCarrito.focus();
  }

  function ocultarHecho(panel) {
    var refs = panel.__vqaRefs;
    estado.anadido = false;
    refs.hecho.hidden = true;
    refs.cta.hidden = false;
    ocultarError(panel);
  }

  function raizDeLaTienda() {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (raiz.charAt(raiz.length - 1) === '/') raiz = raiz.slice(0, -1);
    return raiz;
  }

  var enVuelo = {};

  function seccionesDelCarrito() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    ids.push((window.VeeryCarrito && window.VeeryCarrito.seccionDatos) || 'carrito-datos');
    return ids;
  }

  function carritoDeSecciones(secciones) {
    return window.VeeryCarrito ? window.VeeryCarrito.deSecciones(secciones) : null;
  }

  function eventosShopify() {
    return (window.VeeryCarrito && window.VeeryCarrito.eventos) || null;
  }

  function diferida(m) {
    try {
      if (m) return m.CartLinesUpdateEvent.createPromise();
    } catch (e) {}
    var d = {};
    d.promise = new Promise(function (si, no) { d.resolve = si; d.reject = no; });
    return d;
  }

  function aviso(m, clase, nombre, datos) {
    try {
      if (m) return new m[clase](datos);
    } catch (err) {}
    var e = new Event(nombre, { bubbles: true, cancelable: true });
    for (var k in datos) e[k] = datos[k];
    return e;
  }

  function carritoEstandar(m, carrito) {
    if (!m || !carrito) return carrito || null;
    try { return m.CartLinesUpdateEvent.createCartFromAjaxResponse(carrito); } catch (e) { return null; }
  }

  function confirmarAlta(idVariante) {
    var vivo = document.getElementById('veery-quick-add');
    var p = estado.pendiente;
    if (!vivo || !vivo.__vqaRefs || !vivo.open || !p || p.datos !== estado.datos || String(idVariante) !== String(p.variante)) return;
    estado.pendiente = null;
    mostrarHecho(vivo);
  }

  function anadirPorSuCuenta(idVariante) {
    enviarAlta(eventosShopify(), idVariante);
  }

  function enviarAlta(m, idVariante) {
    var raiz = raizDeLaTienda();
    var secciones = seccionesDelCarrito();
    var anadida = false;
    var promesa = diferida(m);

    document.dispatchEvent(aviso(m, 'CartLinesUpdateEvent', 'shopify:cart:lines-update', {
      action: 'add',
      context: 'dialog',
      lines: [{ merchandiseId: String(idVariante), quantity: 1 }],
      promise: promesa.promise
    }));

    var cuerpo = new FormData();
    cuerpo.append('id', String(idVariante));
    cuerpo.append('quantity', '1');
    cuerpo.append('sections', secciones.join(','));

    fetch(raiz + '/cart/add.js', {
      method: 'POST',
      body: cuerpo,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (respuesta) {
          if (!r.ok || !respuesta || respuesta.status) {
            var fallo = new Error((respuesta && typeof respuesta.message === 'string' && respuesta.message) || 'Add to cart failed');
            fallo.rechazo = r.status === 422 && !!respuesta;
            fallo.descripcion = fallo.rechazo && typeof respuesta.description === 'string' ? respuesta.description : '';
            throw fallo;
          }
          return respuesta;
        });
      })
      .then(function (respuesta) {
        anadida = true;
        var elegida = enVuelo[String(idVariante)];
        delete enVuelo[String(idVariante)];
        if (elegida) guardarEleccion(elegida.handle, null);
        confirmarAlta(idVariante);
        var carrito = carritoDeSecciones(respuesta.sections);
        promesa.resolve({
          cart: carritoEstandar(m, carrito),
          detail: {
            items: carrito ? carrito.items : undefined,
            source: 'veery-quick-add',
            itemCount: 1,
            variantId: idVariante,
            sections: respuesta.sections,
            didError: false
          }
        });
      })
      .catch(function (fallo) {
        if (anadida) return;
        var elegida = enVuelo[String(idVariante)];
        delete enVuelo[String(idVariante)];
        if (elegida) guardarEleccion(elegida.handle, elegida.seleccion);
        var rechazo = !!(fallo && fallo.rechazo);
        var detalle = { source: 'veery-quick-add', variantId: idVariante };
        if (fallo && fallo.descripcion) detalle.description = fallo.descripcion;
        document.dispatchEvent(aviso(m, 'CartErrorEvent', 'shopify:cart:error', {
          error: (fallo && fallo.message) || 'Add to cart failed',
          code: rechazo ? 'INVALID' : 'SERVICE_UNAVAILABLE',
          detail: detalle
        }));
        if (rechazo) {
          promesa.resolve({
            cart: null,
            userErrors: [{ message: detalle.description || (fallo && fallo.message) || '' }],
            detail: { source: 'veery-quick-add', itemCount: 1, variantId: idVariante, didError: true }
          });
        } else {
          promesa.reject(fallo);
        }
      });
  }


  function esHoja() {
    return window.matchMedia('(max-width: 749px)').matches
      && !window.matchMedia('(orientation: landscape) and (max-height: 560px)').matches;
  }

  function animar(panel, entrando) {
    if (typeof panel.animate !== 'function') return null;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
    var hoja = esHoja();
    var pasos = hoja
      ? [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }]
      : [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }];
    if (!entrando) pasos.reverse();
    try {
      panel.animate([{ opacity: entrando ? 0 : 1 }, { opacity: entrando ? 1 : 0 }], {
        duration: 200, easing: 'ease', fill: entrando ? 'none' : 'forwards', pseudoElement: '::backdrop'
      });
    } catch (e) {}
    return panel.animate(pasos, {
      duration: hoja ? 300 : 250,
      easing: hoja ? 'cubic-bezier(0.2, 0.8, 0.2, 1)' : 'ease',
      fill: entrando ? 'none' : 'forwards'
    });
  }

  function bloquearPagina() {
    var html = document.documentElement;
    estado.overflow = html.style.overflow;
    html.style.overflow = 'hidden';
  }

  function soltarPagina() {
    document.documentElement.style.overflow = estado.overflow || '';
    estado.overflow = '';
  }


  var turnoEstilo = 0;
  function conEstilo(seguir) {
    var hoja = document.querySelector('link[data-vqa-estilo]');
    if (!hoja || hoja.media === 'all' || hoja.sheet) {
      if (hoja && hoja.media !== 'all') hoja.media = 'all';
      seguir();
      return;
    }
    var mio = ++turnoEstilo;
    var listo = function () {
      hoja.removeEventListener('load', listo);
      hoja.removeEventListener('error', listo);
      hoja.media = 'all';
      if (mio === turnoEstilo) seguir();
    };
    hoja.addEventListener('load', listo);
    hoja.addEventListener('error', listo);
  }

  function abrir(panel, boton) {
    var tarjeta = boton.closest('.bse__card, [data-vqa-tarjeta]');
    if (!tarjeta) return;

    var bloque = tarjeta.querySelector('[data-vqa-datos]');
    if (!bloque && tarjeta.hasAttribute('data-vqa-producto')) {
      bloque = document.querySelector('[data-vqa-datos][data-vqa-producto="' + tarjeta.getAttribute('data-vqa-producto') + '"]');
    }
    if (!bloque) return;

    var datos;
    try { datos = JSON.parse(bloque.textContent); } catch (e) { return; }
    if (!datos || !datos.variantes || !datos.variantes.length) return;

    estado.datos = datos;
    estado.tarjeta = tarjeta;
    estado.disparador = boton;

    construir(panel, datos);
    panel.classList.add(CLASE_ABIERTO);
    if (!panel.open) {
      bloquearPagina();
      panel.showModal();
      animar(panel, true);
    }
    reiniciarCarrusel(panel);
    pedirGuia(datos).catch(function () {});
  }

  function cerrar(panel, luego) {
    if (!panel.open) { if (luego) luego(); return; }
    if (estado.cerrando) return;
    var anim = animar(panel, false);
    var fin = function () {
      estado.cerrando = false;
      if (panel.open) panel.close();
      if (panel.getAnimations) panel.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); });
      if (luego) luego();
    };
    if (!anim) { fin(); return; }
    estado.cerrando = true;
    anim.finished.then(fin, fin);
  }

  function pasarAlCajon() {
    estado.disparador = null;
    var cajon = document.getElementById('hv-cart-drawer');
    var dialogo = cajon && cajon.querySelector('dialog');
    var enfocar = function () {
      soltarPagina();
      if (!dialogo || !dialogo.open || dialogo.contains(document.activeElement)) return;
      var destino = dialogo;
      var candidatos = dialogo.querySelectorAll('[autofocus]');
      for (var i = 0; i < candidatos.length; i++) {
        if (!candidatos[i].closest('[inert]') && candidatos[i].getClientRects().length) {
          destino = candidatos[i];
          break;
        }
      }
      try { destino.focus({ preventScroll: true }); } catch (e) { destino.focus(); }
    };
    if (!dialogo || dialogo.open) { enfocar(); return; }
    cajon.addEventListener('dialog:open', enfocar, { once: true });
  }

  function restaurarFoco() {
    var disp = estado.disparador;
    estado.disparador = null;
    if (!disp || !document.contains(disp)) return;

    var caja = disp.closest('.bse__quick');
    if (caja) {
      caja.style.transition = 'none';
      caja.classList.add('bse__quick--foco');
    }
    if (!estado.teclado) disp.setAttribute('data-vqa-toque', '');
    var quitar = function () {
      if (caja) {
        caja.style.transition = '';
        caja.classList.remove('bse__quick--foco');
      }
      disp.removeAttribute('data-vqa-toque');
      disp.removeEventListener('blur', quitar);
      disp.removeEventListener('keydown', quitar);
    };
    disp.addEventListener('blur', quitar);
    disp.addEventListener('keydown', quitar);
    try { disp.focus({ preventScroll: true, focusVisible: estado.teclado }); } catch (e) { disp.focus(); }
  }


  function iniciar() {
    var todos = document.querySelectorAll('#veery-quick-add');
    for (var d = todos.length - 1; d > 0; d--) {
      if (todos[d].parentNode) todos[d].parentNode.removeChild(todos[d]);
    }

    var panel = document.getElementById('veery-quick-add');
    if (!panel || panel.__vqaListo) return;
    panel.__vqaListo = true;

    var bloqueTallas = $('[data-vqa-tallas]', panel);
    if (bloqueTallas) {
      try { mapaTallas = JSON.parse(bloqueTallas.textContent) || {}; } catch (e) { mapaTallas = {}; }
    }

    panel.__vqaRefs = {
      titulo: $('[data-vqa-titulo]', panel),
      precio: $('[data-vqa-precio]', panel),
      rebaja: $('[data-vqa-rebaja]', panel),
      antes: $('[data-vqa-antes]', panel),
      pct: $('[data-vqa-pct]', panel),
      legal: $('[data-vqa-legal]', panel),
      artista: $('[data-vqa-artista]', panel),
      eyebrowPor: $('[data-vqa-eyebrow-por]', panel),
      insignia: $('[data-vqa-insignia]', panel),
      imagen: null,
      marcoPerfil: numero(panel.getAttribute('data-vqa-marco-perfil'), 12),
      marcoVuelo: numero(panel.getAttribute('data-vqa-marco-vuelo'), 7.5),
      marcoRecorte: panel.getAttribute('data-vqa-marco-recorte') !== 'false',
      preciosTallas: panel.hasAttribute('data-vqa-precio-tallas'),
      lienzo: $('[data-vqa-lienzo]', panel),
      pista: $('[data-vqa-pista]', panel),
      puntos: $('[data-vqa-puntos]', panel),
      flechaPrev: $('[data-vqa-prev]', panel),
      flechaSig: $('[data-vqa-sig]', panel),
      filaTalla: $('[data-vqa-fila-talla]', panel),
      talla: $('[data-vqa-talla]', panel),
      otras: $('[data-vqa-otras]', panel),
      filaAcabado: $('[data-vqa-fila-acabado]', panel),
      acabado: $('[data-vqa-acabado-lista]', panel),
      marcoNombre: $('[data-vqa-marco-nombre]', panel),
      cta: $('[data-vqa-cta]', panel),
      ctaTexto: $('[data-vqa-cta-texto]', panel),
      ctaPrecio: $('[data-vqa-cta-precio]', panel),
      ctaSep: $('.vqa__cta-sep', panel),
      hecho: $('[data-vqa-hecho]', panel),
      hechoDetalle: $('[data-vqa-hecho-detalle]', panel),
      verCarrito: $('[data-vqa-ver-carrito]', panel),
      enlace: $('[data-vqa-enlace]', panel),
      wish: $('[data-veery-wishlist]', panel),
      guiaBtn: $('[data-vqa-guia]', panel),
      guiaCaja: $('[data-vqa-guia-caja]', panel),
      anuncio: $('[data-vqa-anuncio]', panel),
      error: $('[data-vqa-error]', panel),
      textoError: panel.getAttribute('data-texto-error') || 'Error adding to cart',
      textoAnadir: panel.getAttribute('data-texto-anadir') || 'Add to cart',
      textoAgotado: panel.getAttribute('data-texto-agotado') || 'Sold out',
      textoAnadiendo: panel.getAttribute('data-texto-anadiendo') || 'Adding…',
      textoAnadido: panel.getAttribute('data-texto-anadido') || 'Added to cart',
      textoPor: panel.getAttribute('data-texto-por') || 'by',
      plantillaPunto: panel.getAttribute('data-texto-punto') || 'Image __n__'
    };

    if (!window.__vqaDelegacionRegistrada) {
      window.__vqaDelegacionRegistrada = true;

      document.addEventListener('keydown', function () { estado.teclado = true; }, true);
      document.addEventListener('pointerdown', function () { estado.teclado = false; }, true);

      document.addEventListener('click', function (e) {
        var boton = e.target.closest && e.target.closest('[data-vqa-abrir]');
        if (!boton) return;
        var vivo = document.getElementById('veery-quick-add');
        if (!vivo) return;
        e.preventDefault();
        conEstilo(function () { abrir(vivo, boton); });
      });

      document.addEventListener('cart:error', function (e) {
        var vivo = document.getElementById('veery-quick-add');
        if (!vivo || !vivo.__vqaRefs || !estado.anadiendo) return;
        var d = (e && e.detail) || {};
        var p = estado.pendiente;
        if (d.source !== 'veery-quick-add' || !p || p.datos !== estado.datos || String(d.variantId) !== String(p.variante)) return;
        estado.pendiente = null;
        estado.anadiendo = false;
        if (estado.datos) sincronizar(vivo, estado.datos);
        mostrarError(vivo, window.VeeryCarrito ? window.VeeryCarrito.textoError(d, vivo.__vqaRefs.textoError) : '');
      });

      document.addEventListener('veery:wishlist:change', function () {
        var vivo = document.getElementById('veery-quick-add');
        if (vivo && vivo.__vqaRefs) pintarCorazon(vivo.__vqaRefs);
      });
    }

    panel.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;

      if (t.closest('[data-vqa-cerrar]') || t.closest('[data-vqa-seguir]')) { cerrar(panel); return; }
      if (t.closest('[data-vqa-prev]')) { mostrarMedia(panel, estado.datos, estado.indiceMedia - 1); return; }
      if (t.closest('[data-vqa-sig]')) { mostrarMedia(panel, estado.datos, estado.indiceMedia + 1); return; }

      var punto = t.closest('[data-vqa-punto]');
      if (punto) { mostrarMedia(panel, estado.datos, parseInt(punto.getAttribute('data-vqa-punto'), 10)); return; }

      var talla = t.closest('[data-vqa-talla-valor]');
      if (talla) {
        elegir(panel, talla.getAttribute('data-vqa-opcion-nombre'), talla.getAttribute('data-vqa-talla-valor'));
        return;
      }

      var marco = t.closest('[data-vqa-acabado]');
      if (marco) {
        elegir(panel, marco.getAttribute('data-vqa-opcion-nombre'), marco.getAttribute('data-vqa-valor'));
        return;
      }

      var carrito = t.closest('[data-vqa-ver-carrito]');
      if (carrito) {
        var cajon = document.getElementById('hv-cart-drawer');
        if (cajon && typeof cajon.showDialog === 'function') {
          e.preventDefault();
          estado.haciaCajon = true;
          cajon.showDialog();
          cerrar(panel);
        }
        return;
      }

      if (t.closest('[data-vqa-guia]')) { abrirGuia(panel); return; }

      if (t.closest('[data-vqa-cta]')) { anadir(panel); return; }
    });

    panel.addEventListener('vsg:elegida', function (e) {
      aplicarDesdeGuia(panel, e.detail);
    });

    panel.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-vqa-opcion]');
      if (!sel) return;
      elegir(panel, sel.getAttribute('data-vqa-opcion'), sel.value);
    });

    panel.addEventListener('keydown', function (e) {
      var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
              : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!dir || !e.target.closest) return;

      var radio = e.target.closest('[data-vqa-talla-valor], [data-vqa-acabado]');
      if (radio) {
        e.preventDefault();
        var grupo = radio.hasAttribute('data-vqa-talla-valor')
          ? $$('[data-vqa-talla-valor]', panel.__vqaRefs.talla)
          : $$('[data-vqa-acabado]', panel.__vqaRefs.acabado).filter(function (b) { return !b.hidden; });
        var siguiente = grupo[(grupo.indexOf(radio) + dir + grupo.length) % grupo.length];
        if (!siguiente) return;
        elegir(panel, siguiente.getAttribute('data-vqa-opcion-nombre'),
          siguiente.getAttribute(siguiente.hasAttribute('data-vqa-talla-valor') ? 'data-vqa-talla-valor' : 'data-vqa-valor'));
        siguiente.focus();
        return;
      }

      if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && e.target.closest('.vqa__galeria')) {
        e.preventDefault();
        mostrarMedia(panel, estado.datos, estado.indiceMedia + dir);
      }
    });

    panel.addEventListener('mousedown', function (e) {
      if (e.target !== panel) return;
      var r = panel.getBoundingClientRect();
      var dentro = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!dentro) cerrar(panel);
    });

    panel.addEventListener('cancel', function (e) {
      e.preventDefault();
      cerrar(panel);
    });

    panel.addEventListener('close', function () {
      var alCajon = estado.haciaCajon;
      estado.haciaCajon = false;
      panel.classList.remove(CLASE_ABIERTO);
      estado.anadiendo = false;
      estado.pendiente = null;
      ocultarHecho(panel);
      if (alCajon) {
        pasarAlCajon();
        return;
      }
      soltarPagina();
      restaurarFoco();
    });


    activarArrastre(panel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
})();
